import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"
import NetworkAd from "components/network-ad"

export const NetworkAdUnit = styled(NetworkAd)`
  min-height: 9rem;
  margin: 0;
  padding-top: 1rem;
`

export const Container = styled.div`
  position: sticky;
  z-index: 10;
  bottom: 0;
  width: 100%;
  min-height: 12.2rem;
  display: none;
  background-color: rgba(255, 255, 255, 0.8);

  section {
    background-color: transparent;
  }

  ${minWidth.desktop`
    display: block;
  `}
`

export const CloseButton = styled.div`
  position: absolute;
  top: -3rem;
  right: 0;
  width: 14.3rem;
  height: 3rem;
  border-top-left-radius: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.0833;
  text-transform: uppercase;
  color: #222;
  background-color: #fff;
  cursor: pointer;
`

export const ArrowIcon = styled(Icon)`
  margin-left: 0.7rem;
  transform: translateY(-0.1rem) rotate(90deg) scale(0.8);
`
